export default __webpack_public_path__ + "static/media/Guaranteed-Income-Star-Brochure.7f181812.pdf";